export default __webpack_public_path__ + "fb5d847e0801ee28f1e422bb735b4353.png";